import { Form, Errors } from 'vform'

Form.prototype.hasFiles = false

Form.prototype.data = function() {
	const data = this.keys().reduce((data, key) => (
      { ...data, [key]: this[key] }
    ), {})


	if (this.hasFiles) {
		const formData = new FormData()

		buildFormData(formData, data)

		return formData
	}

	return data
}

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' &&
        !(data instanceof Date) &&
        !(data instanceof File) &&
        !(data instanceof Blob) &&
        !(Array.isArray(data) && !data.length)
    ) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
        })
    } else {
        let value = data == null ? '' : data

        if (typeof value === 'boolean') {
            value = Number(value)
        }

        formData.append(parentKey, value)
    }
}

Errors.prototype.first = function () {
	return this.flatten()[0]
}


// WEBPACK FOOTER //
// ./src/config/vform.js